<div class="contact-container">
  <h2>Contact Us</h2>
  <p>Have a question or need help? Fill out the form below and we’ll get back to you soon.</p>
  <form>
    <div class="form-group">
      <label for="name">Name</label>
      <input id="name" name="name" type="text" class="form-control" required>
    </div>
    <div class="form-group">
      <label for="email">Email</label>
      <input id="email" name="email" type="email" class="form-control" required>
    </div>
    <div class="form-group">
      <label for="message">Message</label>
      <textarea id="message" name="message" rows="5" class="form-control" required></textarea>
    </div>
    <button type="submit" class="btn btn-primary mt-2">Send Message</button>
  </form>
  <div class="contact-details mt-4">
    <h5>Our Office</h5>
    <p>Middleboro, MA, United States</p>
    <p>Email: <a href="mailto:info@paulandsons.com">info@alreadydone.us</a></p>
    <p>Phone: <a href="tel:+15089717548">(508) 971-7548</a></p>
  </div>
</div>

<style>
.contact-container {
  max-width: 500px;
  margin: 40px auto;
  background: #fff;
  padding: 32px 24px;
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
}
.contact-container h2 {
  margin-bottom: 16px;
  font-weight: 700;
}
.form-group {
  margin-bottom: 16px;
}
.form-control {
  width: 100%;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #ccc;
}
.btn-primary {
  background: #23272b;
  border: none;
  color: #fff;
  padding: 10px 28px;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
}
.btn-primary:hover {
  background: #ffc107;
  color: #23272b;
}
.contact-details {
  margin-top: 32px;
  font-size: 1rem;
}
.contact-details a {
  color: #23272b;
  text-decoration: underline;
}
</style>
